import React, { useEffect, useMemo, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import {getDetailsPpid, getMenuListPpid, getDetailById, getFileById} from "redux/ppid/ppidActions"
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";
import ChatBox from "../PopUp/ChatBox";
import { useSelector, useDispatch } from "react-redux";
import Submenu from "./component/submenu"
import Detail from "./component/detail"
// import LayananPublik from "./LayananPublik";
import RegistrasiPermohonan from "./RegistrasiPermohonan";
import useRedux from "redux/useRedux";
import FroalaEditorView from "components/reuseable/FormInput/FroalaEditorTextArea";
import dummy from "assets/images/dummy/1.png";
import { getHeaderUrlImg } from "redux/global/globalActions";
import { uAPI } from "api/config";

const PPID = ({ children }) => {
  const lang = localStorage.getItem('i18nextLng');
  const location = useLocation();
  const { pathname } = location;
  const [loadingDetail, setLoadingDetail] = useState(false)

  const {
    // dispatch,
    global: { menu, menuSidebar, activeMenuSidebar, headerUrlImg },
    profil: { anakPerusahaan },
  } = useRedux();
  
  const [header, setHeader] = useState("");

  
  // const [titleList, setTitleList] = useState([]);
  // const [detail, setDetail] = useState([]);
  let selector = useSelector((state)=>state.ppid)
  const dispatch = useDispatch()

  // const handleOnClick = async (id) => {
  //   if(id){
  //     setLoadingDetail(true)
  //     let params = "?id="+id 
  //     let paramsFile = "?id_table_menu="+id 
  //     await Promise.all([
  //       dispatch(getDetailById(params)),
  //       dispatch(getFileById(paramsFile))
  //     ])
  //     setLoadingDetail(false)
  //   }
  // }
  useEffect(() => {
    dispatch(getHeaderUrlImg());
  }, [location])
  const handleOnClick = async (id) => {
    if (!id) return;  // 🛑 kalau id kosong jangan dispatch
  
    setLoadingDetail(true)
    let params = "?id=" + id 
    let paramsFile = "?id_table_menu=" + id 
    await Promise.all([
      dispatch(getDetailById(params)),
      dispatch(getFileById(paramsFile))
    ])
    setLoadingDetail(false)
  }
    
    useEffect(() => {
      if (!headerUrlImg) return;
    
      const found = headerUrlImg?.find((va) => va.image_name === "E-PPID");
      // const found = headerUrlImg.find(item => item.image_name === menuSidebar?.title);
    
      if (found) {
        setHeader(found); // bisa juga setHeader(found.image) kalau kamu hanya butuh url-nya
      }
    }, [headerUrlImg]);
  
  useEffect(()=> {
    dispatch(getDetailsPpid())
    dispatch(getMenuListPpid())
  },[dispatch])

  useEffect(() => {
    console.log("DETAIL BY ID:", selector?.detailById)
  }, [selector?.detailById])
  // selector?.detailById?.map((vals)=> console.log("Selector vals.menu", vals.menu) )
  // console.log("console headerUrlImg", headerUrlImg)
  // console.log("header.image_name.some((va)) : ", headerUrlImg?.find((va)=> va.image_name === "E-PPID") )
  return (
    <>
      {/* === akhir tag container === */}
      <div className="mt-[110px] ">

        {/* ===== Awal Banner Title ===== */}
        <div className="slideshow-header w-screen h-screen relative overflow-hidden">
          {/* Teks di tengah */}
          <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center z-10">
            <div className="text-white text-[40px] font-semibold uppercase text-center drop-shadow-lg">
              <div className="froala-view-wrapper">
              {
                // header?.description && header.image_name === menuSidebar.title ? 
                header?.description && header.image_name.includes("PPID") ? 
                <FroalaEditorView
                      model={lang === "en" ? (header?.description_en ? header?.description_en : header?.description) :header?.description}
                /> :
                <div className="text-white text-[40px] font-semibold uppercase text-center">
                  {selector?.detailById?.map((vals)=> `${lang === "en" ? (vals.menu_en ? vals.menu_en : vals.menu) : vals.menu}` )}
                </div>
              }
              </div>
            </div>
          </div>

          {/* Gambar background */}
          {/* <img
            src={header?.image ? uAPI + header.image : dummy}
            alt="banner"
            className="w-screen h-screen object-cover absolute top-0 left-0"
          /> */}
          <img
            src={header?.image ? uAPI + header.image : dummy}
            alt="banner"
            className="w-screen h-screen object-cover absolute top-0 left-0"
            loading="lazy"   // 🟢 tambahkan lazy loading
          />
        </div>
        {/* ===== Akhir Banner Title ===== */}

        {/* ===== Awal menu side bar dan konten ===== */}
        <div className="flex ">
        
          {/*  ====== start Div untuk menu side bar ======*/}
          <div className="flex-4 sectio md:grid md:grid-cols-1 p-6 md:block">
                  <div className="hidden md:flex md:flex-col md:mr-2">
                    <div className="text-inactive text-[17px] mb-4">
                    {selector?.menuList?.map((val) => (
                        <Disclosure key={val.id}> 
                            {({ open }) => (
                                <div key={val.id}>
                                    <Disclosure.Button
                                    className="flex w-full justify-between rounded-lg  px-4 py-2 text-left text-sm text-[15px] ml-10 p-[14px] text-gray-1500 hover:bg-[#F0F2F2] focus:outline-none focus-visible:ring focus-visible:ring-gray-500 focus-visible:ring-opacity-75 gap-7"
                                    // onClick={setIdTitle(val.id)}
                                    >
                                    <div onClick={() => handleOnClick(val?.submenu?.length > 0 ? null : val.id)}>
                                        <div className="my-1 text-[17px] ">{`${lang === "en" ? (val.menu_en ? val.menu_en :val.menu  ) : val.menu}`}</div>
                                    </div>
                                    {val?.submenu?.length > 0? (  
                                        <ChevronUpIcon
                                            className={`  ${
                                                open ? "rotate-180 transform" : ""
                                            } h-5 w-5 text-primary-500`}
                                        />) : null}
                                    </Disclosure.Button>
                                    {val?.submenu?.length > 0? <Submenu items={val.submenu} /> : null}
                                </div>
                            )}
                        </Disclosure>
                    ))}
                    </div>
                  </div>
          </div>
          {/*  ====== akhir Div untuk menu side bar ======*/}
          
          {/* ===== Garis Pemisah ===== */}
          <div className="border-l border-gray-300"></div>
          
          {/* ===== Awal isi Detail ===== */}
          {/* {
          //  <RegistrasiPermohonan/>
          selector?.detailById?.map((va)=> `${va.id}`) == "11" ? <RegistrasiPermohonan/> : <Detail detail={selector?.detailById} file={selector?.fileById}/>
          } */}
            {loadingDetail ? (
              <div className="p-4">Loading...</div>
            ) : !selector?.detailById || selector?.detailById.length === 0 ? (
              <div className="p-4">Tidak ada data ditemukan</div>
            ) : (
              selector?.detailById?.some((va)=> `${va.id}` === "11") 
                ? <RegistrasiPermohonan/> 
                : <Detail detail={selector?.detailById} file={selector?.fileById}/>
            )}
          {/* ===== Akhir isi Detail ===== */}

        </div>
        {/* Akhir menu side bar dan konten */}

      </div>
      {/* === akhir tag container === */}
      <ChatBox />
    </>
  );
 
}

export default PPID;
